import React from "react";
import { AppBuilderComponent } from "../../../../AppBuilder/AppBuilder";
import { useWorkflow } from "../../../../context/WorkflowContext";
import { useWorkflowGeneration } from "../../../../context/WorkflowGenerationContext";
import { useWorkflowExecution } from "../../../../context/WorkflowExecutionContext";
import { useCanvasContext } from "../WorkflowCanvasContext";

export default function PreviewTab({ step }) {
    const { workflow, steps, testData } = useWorkflow();
    const { codeVersionNumber, handleErrorLog } = useWorkflowGeneration();
    const {
        executionId,
        setExecutionId,
        handleStepTestResults,
        startWorkflow,
        setStepExecutionLogs,
        pausedStepId,
    } = useWorkflowExecution();
    const { setSelectedNodeId } = useCanvasContext();
    const publicKey = workflow?.publicKey;

    const handleOnSubmit = React.useCallback(
        async (data) => {
            handleStepTestResults(data.stepId, data.stepData, []);
            setExecutionId(data.executionId);
            await startWorkflow(data.stepData, data.stepId, data.executionId);

            // Auto-select next step after submission (if engine didn't pause at another step)
            const currentIndex = steps.findIndex((s) => s.id === data.stepId);
            if (currentIndex !== -1 && currentIndex < steps.length - 1) {
                setSelectedNodeId(steps[currentIndex + 1].id);
            }
        },
        [handleStepTestResults, startWorkflow, setExecutionId, steps, setSelectedNodeId]
    );

    const handleSetLogs = React.useCallback(
        (logs) => {
            setStepExecutionLogs((prev) => ({
                ...prev,
                [step.id]: logs,
            }));
        },
        [step.id, setStepExecutionLogs]
    );

    if (!publicKey) {
        return (
            <div className="flex items-center justify-center h-64 text-sm text-gray-400">
                No public key available for preview
            </div>
        );
    }

    return (
        <div className="relative w-full overflow-auto min-h-[400px] h-[calc(100vh-160px)]">
            <div className="w-full absolute top-0 left-0">
                <AppBuilderComponent
                    onSubmit={handleOnSubmit}
                    isForPreview={true}
                    defaultStepId={step.id}
                    publicKey={publicKey}
                    key={publicKey + step.id + codeVersionNumber}
                    handleErrorLog={handleErrorLog}
                    defaultExecutionId={executionId}
                    testData={testData}
                    handleSetLogs={handleSetLogs}
                />
            </div>
        </div>
    );
}
